<template>
  <div class="container">
    <div class="mwow-detail-header">
      <div class="left">
        <div class="back-btn" @click="$router.go(-1)">
          <i class="el-icon-arrow-left"></i>
          <span>返回</span>
        </div>
      </div>
      <div class="mid">
        <p>体验课课表</p>
      </div>
      <div class="right"></div>
    </div>
    <div class="range-wrap">
      <range-dialog></range-dialog>
    </div>
    <el-form
      size="mini"
      :model="searchInfo"
      label-width="64px"
      class="search-form"
    >
      <el-row>
        <el-col :span="8">
          <el-form-item label="班级名称:" prop="class_id">
            <el-select
              v-model="searchInfo.class_id"
              filterable
              clearable
              placeholder="请选择"
              :filter-method="handleSearchClass"
              @change="refreshCalendar"
            >
              <el-option
                v-for="item in classList"
                :key="item.class_id"
                :label="item.name"
                :value="item.class_id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="排课课程:" prop="course_id">
            <el-select
              v-model="searchInfo.course_id"
              filterable
              clearable
              placeholder="请选择"
              :filter-method="handleSearchCourse"
              @change="refreshCalendar"
            >
              <el-option
                v-for="item in courseList"
                :key="item.course_id"
                :label="item.title"
                :value="item.course_id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="授课教师:" prop="teacher_id">
            <common-staff-pull-down
              :originId.sync="searchInfo.teacher_id"
              :defaultSelected.sync="searchInfo.teacher_list"
              :jobIds="[1]"
              @change="refreshCalendar"
            ></common-staff-pull-down>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="授课模式:" prop="lesson_type">
            <el-radio-group
              v-model="searchInfo.lesson_type"
              @change="refreshCalendar"
            >
              <el-radio-button :label="-1">全部</el-radio-button>
              <el-radio-button :label="1">线下</el-radio-button>
              <el-radio-button :label="2">线上</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="班级类型:" prop="course_type">
            <el-radio-group
              v-model="searchInfo.course_type"
              @change="refreshCalendar"
            >
              <el-radio-button :label="-1">全部</el-radio-button>
              <el-radio-button :label="1">1vN</el-radio-button>
              <el-radio-button :label="2">1v1</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="full-calendar-wrap">
      <el-button
        class="mwow-button-filled success add-dialog-btn"
        @click="openAddDialog"
        >添加体验课</el-button
      >
      <FullCalendar :options="calendarOptions" ref="fullCalendar">
        <template v-slot:eventContent="arg">
          <div class="el-popover-wrap">
            <el-popover
              placement="bottom"
              width="220"
              trigger="hover"
              @show="getLessonInfo(arg)"
              :open-delay="100"
              :close-delay="100"
              popper-class="schedule-popper"
            >
              <div class="event-hover-dialog">
                <div class="content">
                  <p class="p1">
                    <span
                      class="mwow-tag type-label"
                      v-if="arg.event._def.extendedProps.class_type === 1"
                      >正课</span
                    >
                    <span
                      class="mwow-tag type-label"
                      v-if="arg.event._def.extendedProps.class_type === 2"
                      >体验</span
                    >
                    <span
                      class="mwow-tag type-label"
                      v-if="arg.event._def.extendedProps.class_type === 3"
                      >补课</span
                    >
                    {{ arg.event._def.title }}
                  </p>
                  <p class="p1">
                    {{ arg.event._def.extendedProps.day
                    }}{{ arg.event._def.extendedProps.time }}
                  </p>
                  <p class="p1">
                    授课教师：{{ arg.event._def.extendedProps.teacher || "-" }}
                  </p>
                  <p class="p1">
                    排课课程：{{ arg.event._def.extendedProps.course || "-" }}
                  </p>
                  <p class="p1">
                    <span
                      >授课模式：{{
                        arg.event._def.extendedProps.type || "-"
                      }}</span
                    >
                    <img
                      v-if="arg.event._def.extendedProps.lesson_type === 2"
                      src="https://wowsite.musicwow.com/teaching_system_frontend/images/live-logo.png"
                      height="12"
                    />
                  </p>
                  <p class="p1">
                    <span
                      >上课教室：{{
                        arg.event._def.extendedProps.class_room
                          ? arg.event._def.extendedProps.class_room.name
                          : "-"
                      }}</span
                    >
                  </p>
                  <p class="p3">
                    <span>
                      班级排课：( 已点 {{ courseClass.finish_lesson_count }} /
                      总 {{ courseClass.arrange_lesson_count }}课时)
                    </span>
                  </p>
                  <div class="p2">
                    <p>
                      班级人数：（{{
                        arg.event._def.extendedProps.current_student_count
                      }}
                      /
                      {{
                        arg.event._def.extendedProps.preset_student_count
                      }}人）
                    </p>
                    <p>
                      上课学员：{{
                        arg.event._def.extendedProps.student || "-"
                      }}
                    </p>
                  </div>
                </div>
                <!-- v-show="arg.event._def.extendedProps.student.includes(studentName)" -->
                <!-- v-show="arg.event._def.extendedProps.student.indexOf('studentName' != -1)" -->
                <div class="btns" v-show="showExperience">
                  <div
                    class="btn green"
                    v-if="arg.event._def.extendedProps.course_type === 1"
                    @click="handleFollow(arg.event._def)"
                  >
                    跟班体验
                  </div>
                </div>
              </div>
              <div slot="reference">
                <div
                  class="calendar-event"
                  :style="`background-color:${
                    arg.event._def.extendedProps.sign_status === 2
                      ? '#B8B8B8'
                      : arg.backgroundColor
                  };`"
                >
                  <div class="text">
                    <p>
                      {{ formatTime(arg.event.start) }}-{{
                        formatTime(arg.event.end)
                      }}
                      <span
                        class="tag"
                        v-if="arg.event._def.extendedProps.temporary_status"
                        >临时</span
                      >
                      <span
                        class="tag"
                        v-else-if="
                          arg.event._def.extendedProps.sign_status === 2
                        "
                        >已点</span
                      >
                    </p>
                    <p v-if="arg.view.type !== 'dayGridMonth'">
                      {{ arg.event._def.extendedProps.teacher || "-" }}
                    </p>
                    <p>{{ arg.event.title || "-" }}</p>
                  </div>
                </div>
              </div>
            </el-popover>
          </div>
        </template>
      </FullCalendar>
    </div>
    <el-drawer
      title="新增体验课"
      :visible.sync="listingDialogVisible"
      direction="rtl"
      :size="480"
      destroy-on-close
    >
      <add-dialog
        :originTime="addDialogTime"
        :visible.sync="listingDialogVisible"
        @change="refreshCalendar"
      ></add-dialog>
    </el-drawer>
    <el-drawer
      title="跟班体验"
      :visible.sync="followDialogVisible"
      direction="rtl"
      :size="480"
      destroy-on-close
    >
      <follow-dialog
        :lessonId="followDialogId"
        :visible.sync="followDialogVisible"
        @change="refreshCalendar"
      ></follow-dialog>
    </el-drawer>
  </div>
</template>
<script>
import eventBus from "@/utils/bus";
import FullCalendar, { CalendarOptions } from "@fullcalendar/vue";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import { dateFormat } from "@/utils/timeFormat";
import rangeDialog from "@/view/teachManagement/storeSchedule/rangeDialog.vue";
import { timeTable, lessonDetail, getRange } from "@/api/schedule";
import addDialog from "./addDialog.vue";
import followDialog from "./followDialog.vue";
import { getSelectClassList, getSelectCourseList } from "@/api/globalSearch";
import commonStaffPullDown from "@/components/commonStaffPullDown.vue";
import { addLessonStudent } from "@/api/lesson";

export default {
  name: "experienceSchedule",
  components: {
    FullCalendar,
    addDialog,
    rangeDialog,
    followDialog,
    commonStaffPullDown,
  },
  data() {
    return {
      showExperience: false,
      studentName: "",
      courseClass: {}, // 班级排课信息,
      studentAdd: {}, // 课次学员添加
      classList: [],
      courseList: [],
      listingDialogVisible: false,
      followDialogVisible: false,
      searchInfo: {
        lesson_type: -1,
        course_type: -1,
        teacher_id: "",
        teacher_list: [],
      },
      addDialogTime: {},
      followDialogId: 0,
      numToWeekCh: {
        0: "日",
        1: "一",
        2: "二",
        3: "三",
        4: "四",
        5: "五",
        6: "六",
      },
      calendarOptions: {
        plugins: [timeGridPlugin, interactionPlugin],
        initialView: "timeGridWeek",
        firstDay: 1,
        locale: "zh-cn",
        eventBorderColor: "#ffffff",
        themeSystem: "bootstrap",
        allDaySlot: false,
        slotDuration: "00:30:00",
        slotLaneClassNames: "sechdule-lane",
        headerToolbar: {
          left: "today",
          center: "prev title next",
          right: "",
        },
        buttonText: {
          today: "本周",
        },
        slotLabelFormat: {
          hour: "2-digit",
          minute: "2-digit",
          meridiem: false,
          hour12: false,
        },
        events: (info, successCallback, failureCallback) => {
          const params = {
            start_date: dateFormat("YYYY-mm-dd", info.start),
            end_date: dateFormat("YYYY-mm-dd", info.end),
          };
          if (this.searchInfo.course_id) {
            params.course_ids = [this.searchInfo.course_id];
          }
          if (this.searchInfo.class_id) {
            params.class_ids = [this.searchInfo.class_id];
          }
          if (this.searchInfo.teacher_id) {
            params.teacher_ids = [this.searchInfo.teacher_id];
          }
          if (Number(this.searchInfo.lesson_type) >= 0) {
            params.lesson_type = Number(this.searchInfo.lesson_type);
          }
          if (Number(this.searchInfo.course_type) >= 0) {
            params.course_type = Number(this.searchInfo.course_type);
          }
          timeTable(params).then((res) => {
            if (res.error_code === 0) {
              // 过滤当前月
              let curM = 0;
              if (info.start.getDate() !== 1) {
                curM = info.start.getMonth() + 2;
              } else {
                curM = info.start.getMonth() + 1;
              }
              curM = curM > 12 ? curM - 12 : curM;
              const arr = [];
              let all = 0;
              let signed = 0;
              res.data.date_list.map((date) => {
                date.lesson_list.map((lesson) => {
                  if (Number(lesson.date.slice(5, 7)) === curM) {
                    all = all + 1;
                    if (lesson.roll_call_status === 2) {
                      signed = signed + 1;
                    }
                  }
                  const teachers = [];
                  lesson.teacher_list.map((item) => {
                    teachers.push(item.name);
                  });
                  const tstr = teachers.join(",");
                  arr.push({
                    title: lesson.class.name,
                    start: `${lesson.date} ${lesson.start_time}`,
                    end: `${lesson.date} ${lesson.end_time}`,
                    backgroundColor:
                      lesson.roll_call_status === 2
                        ? "#B8B8B8"
                        : lesson.course.color,
                    lid: lesson.lesson_id,
                    rid: lesson.roll_call_id,
                    teacher: tstr,
                    day: `${lesson.date.slice(5)}（周${
                      this.numToWeekCh[lesson.week_day]
                    }）`,
                    time: `${lesson.start_time.slice(
                      0,
                      5
                    )} ~ ${lesson.end_time.slice(0, 5)}`,
                    course: lesson.course.title,
                    lesson_type: lesson.lesson_type,
                    type:
                      lesson.lesson_type === 1
                        ? "线下 - 门店授课"
                        : "线上 - 直播授课",
                    sign_status: lesson.roll_call_status,
                    temporary_status: lesson.include_temporary_student,
                    course_type: lesson.course.course_type,
                    class_type: lesson.class.class_type,
                  });
                });
              });
              successCallback(arr);
            }
          });
        },
        editable: false,
        dateClick: this.openAddDialog,
        slotEventOverlap: false,
      },
    };
  },

  created() {
    this.studentName = this.$route.query.sname;
  },
  mounted() {
    eventBus.$on("schedule-range-change", (arr) => {
      const calendarApi = this.$refs.fullCalendar.getApi();
      calendarApi.setOption("slotMinTime", arr[0]);
      calendarApi.setOption("slotMaxTime", arr[1]);
      this.refreshCalendar();
    });
    getRange().then((res) => {
      if (res.error_code === 0) {
        if (res.data.end_time === "00:00:00") {
          res.data.end_time = "23:55:00";
        }
        const calendarApi = this.$refs.fullCalendar.getApi();
        calendarApi.setOption("slotMinTime", res.data.start_time);
        calendarApi.setOption("slotMaxTime", res.data.end_time);
      }
    });
    eventBus.$on("collapse", () => {
      this.refreshCalendar();
    });
    this.handleSearchClass("");
    this.handleSearchCourse("");
  },
  beforeDestroy() {
    eventBus.$off("schedule-range-change");
    eventBus.$off("collapse");
  },
  methods: {
    formatTime(time) {
      let h = time.getHours();
      let m = time.getMinutes();
      h = h < 9 ? "0" + h : String(h);
      m = m < 9 ? "0" + m : String(m);
      return h + ":" + m;
    },
    handleSearchClass(v) {
      getSelectClassList({
        page: 1,
        page_size: 50,
        name: v,
      }).then((res) => {
        if (res.error_code === 0) {
          this.classList = res.data.list;
        }
      });
    },
    handleSearchCourse(v) {
      getSelectCourseList({
        page: 1,
        page_size: 50,
        title: v,
      }).then((res) => {
        if (res.error_code === 0) {
          this.courseList = res.data.list;
        }
      });
    },
    getLessonInfo(arg) {
      const id = arg.event._def.extendedProps.lid;
      const event = arg.event;
      lessonDetail({
        lesson_id: id,
      }).then((res) => {
        if (res.error_code === 0) {
          this.courseClass = res.data.class;
          this.studentAdd = res.data;
          const students = [];
          if (res.data.roll_call_status === 2) {
            res.data.roll_call_student_list.map((item) => {
              students.push(item.student.name);
            });
          }
          if (res.data.roll_call_status === 1) {
            res.data.student_list.map((item) => {
              students.push(item.name);
            });
          }
          this.showExperience = !students.includes(this.studentName);
          let str = "";
          if (students.length > 10) {
            str = students.join(",") + "...";
          } else {
            str = students.join(",") || "无";
          }
          event.setExtendedProp("student", str);
          event.setExtendedProp(
            "current_student_count",
            res.data.class.current_student_count
          );
          event.setExtendedProp(
            "preset_student_count",
            res.data.class.preset_student_count
          );
          event.setExtendedProp("class_room", res.data.classroom);
        }
      });
    },
    refreshCalendar() {
      const calendarApi = this.$refs.fullCalendar.getApi();
      calendarApi.refetchEvents();
    },

    openAddDialog(data) {
      if (data && data.date) {
        this.addDialogTime = {
          date: dateFormat("YYYY-mm-dd", data.date),
          start: dateFormat("HH:MM", data.date),
          end: dateFormat("HH:MM", data.date.getTime() + 30 * 60 * 1000),
        };
      } else {
        this.addDialogTime = {
          date: dateFormat("YYYY-mm-dd", new Date()),
          start: "12:00",
          end: "13:00",
        };
      }
      this.listingDialogVisible = true;
    },
    handleFollow(confirmInfo) {
      if (this.$route.query.show_follow_dialog_id) {
        this.followDialogId = confirmInfo.extendedProps.lid;
        this.followDialogVisible = true;
        return;
      }
      this.$confirm(
        `确定将学员跟随班级 [${confirmInfo.title}],时间 ${
          confirmInfo.extendedProps.day + confirmInfo.extendedProps.time
        } ，课次体验？`,
        `跟班体验 - 已选择 ${this.$route.query.sid ? 1 : 0} 人`,
        {
          confirmButtonText: "确定",
          confirmButtonClass: "mwow-button-filled success mini",
          cancelButtonText: "取消",
          cancelButtonClass: "mwow-button-filled mini",
          type: "warning",
        }
      )
        .then(() => {
          const params = {
            lesson_id: this.studentAdd.lesson_id,
            student_type: 5,
            in_roll_call: false,
            student_list: [],
          };
          params.student_list.push({
            student_id: this.$route.query.sid,
            course_id: this.studentAdd.course_id,
          });
          addLessonStudent(params).then(() => {
            this.$message({
              type: "success",
              message: "添加成功!",
            });
            this.$router.go(-1);
          });
        })
        .catch(() => {});
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  background-color: #ffffff;
  padding: 0 12px 12px 12px;
  border-radius: 4px;
  position: relative;
  .mwow-detail-header {
    margin-bottom: 22px;
  }
  .range-wrap {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 998;
  }
  .add-dialog-btn {
    position: absolute;
    left: 0;
    top: 0;
  }
}
/deep/.search-form {
  .el-select {
    width: 150px;
  }
}
/deep/ a:hover {
  color: #5c5d5e !important;
  box-shadow: none !important;
}
/deep/ .full-calendar-wrap {
  position: relative;
  height: calc(100vh - 190px);
  .fc {
    height: 100%;
  }
  .more-link {
    position: absolute;
    top: -15px;
    right: 5px;
    color: #5c5d5e;
    text-align: right;
    font-size: 12px;
    line-height: 12px;
  }
  .fc-header-toolbar {
    justify-content: center;
    .fc-toolbar-chunk {
      margin: 0 12px;
    }
    .fc-toolbar-title {
      display: inline-block;
      vertical-align: top;
      line-height: 28px;
      font-size: 12px;
    }
    .fc-button {
      line-height: 23px;
      height: 28px;
      font-size: 12px;
      padding: 0 8px;
      border: 1px solid #e7e8ea;
      background-color: #ffffff;
      color: #5c5d5e;
      &:focus {
        box-shadow: none;
      }
    }
    .fc-button-group {
      .fc-button {
        padding: 0 12px;
      }
      .fc-button-active {
        border-color: #38dabb;
        color: #38dabb;
        background: #f0fdfa;
      }
    }
  }
  .fc-view-harness {
    .fc-scrollgrid-section-header {
      .fc-col-header {
        line-height: 40px;
        background: #f2f6fa;
        font-size: 12px;
        color: #5c5d5e;
      }
    }
  }
  .fc-daygrid-event {
    background-color: rgba(0, 0, 0, 0) !important;
    display: block;
    margin: 0 5px 5px 5px !important;
    padding: 0;
  }
  .fc-v-event {
    padding: 0;
    // border: 0;
    .fc-event-main {
      padding: 0;
      position: relative;
    }
  }
  .fc-timegrid-event {
    box-shadow: none;
  }
  .event-head {
    flex: 1;
    font-size: 12px;
    line-height: 16px;
    margin: 2px 5px 0 5px;
    .solar {
      color: #5c5d5e;
      margin-right: 6px;
    }
    .lunar {
      color: #9d9e9e;
    }
  }
}
.calendar-event {
  text-align: left;
  color: #ffffff;
  font-size: 12px;
  line-height: 16px;
  // border: 1px solid #ffffff;
  min-height: 100%;
  // box-shadow: 0 0 1px 1px #eee;
  overflow: hidden;
  .text {
    white-space: initial;
    padding: 3px 8px;
    position: relative;
    p:first-child {
      padding-right: 36px;
    }
    .tag {
      background: #888888;
      line-height: 18px;
      width: 32px;
      border-bottom-left-radius: 4px;
      text-align: center;
      position: absolute;
      top: 0;
      right: 0;
    }
    p {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
/deep/.el-popover-wrap {
  height: 100%;
  & > span {
    display: block;
    height: 100%;
    & > .el-popover__reference-wrapper {
      display: block;
      height: 100%;
      & > .el-popover__reference {
        display: block;
        height: 100%;
        & > .main-wrap {
          display: block;
          height: 100%;
          & > div {
            display: block;
            height: 100%;
            & > .calendar-event {
              display: block;
              height: 100%;
            }
          }
        }
      }
    }
  }
}
.event-hover-dialog {
  margin: -12px;
  .content {
    padding: 12px;
    color: #5c5d5e;
    .p1 {
      font-size: 13px;
      line-height: 22px;
      span {
        vertical-align: middle;
      }
      img {
        vertical-align: middle;
        margin-left: 6px;
      }
    }
    .p2 {
      font-size: 12px;
      line-height: 22px;
      border-top: 1px solid #cbcbcb;
      padding-top: 8px;
      margin-top: 4px;
    }
  }
  .btns {
    display: flex;
    .btn {
      flex: 1;
      line-height: 30px;
      text-align: center;
      font-size: 12px;
      cursor: pointer;
      &.green {
        color: #07d1aa;
        background: #f0fdfa;
      }
    }
  }
}
.p3 {
  font-size: 12px;
  line-height: 22px;
  border-top: 1px solid #cbcbcb;
  padding-top: 4px;
  margin-top: 4px;
}
/deep/.sechdule-lane {
  height: 75px;
  cursor: pointer;
}
/deep/ .el-form {
  .el-form-item {
    margin-right: 58px;
    .el-select {
      width: 100%;
    }
    .el-date-editor {
      width: 100%;
    }
  }
}
@media screen and (max-width: 1575px) {
  /deep/ .full-calendar-wrap {
    height: calc(100vh - 240px);
  }
}
</style>
